import React from 'react';
import { connect } from 'react-redux';
import { GetDHCDetails } from '../../Services/Actions';
import { useParams } from 'react-router-dom';
import history from '../../history';

import Avatar from '@mui/material/Avatar';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';

import Dashboard from './Dashboard';
// import DHCs from './DHCs';
// import EndUsers from './EndUsers';
// import Products from './Products';

import BudgetIcon from '@mui/icons-material/AttachMoney';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EndUserIcon from '@mui/icons-material/AccountCircle';
import ProductIcon from '@mui/icons-material/Inventory';

const TAB_TYPES = [
    { id: 1, IconName: DashboardIcon, TabLabel: 'Dashboard', Value: 'Dashboard' },
    { id: 2, IconName: ProductIcon, TabLabel: 'Products', Value: 'Products' },
    { id: 3, IconName: EndUserIcon, TabLabel: 'End Users', Value: 'EndUsers' },
    { id: 4, IconName: BudgetIcon, TabLabel: 'Budget', Value: 'Budget' }
]

function DHCDetailWrapper(props) {
    const params = useParams();
    return <DHCDetailComponent DHCId={params.DHCId} {...props} />;
}

class DHCDetailComponent extends React.Component {
    state = {
        DHCDetails: {},
        DHCId: null,
        SelectedTab: null
    }

    componentDidMount() {
        var { DHCId } = this.props;
        DHCId = +DHCId;

        if (!DHCId) history.push('/dashboard');

        const params = new URLSearchParams(window.location.search);
        let tab = params.get('tab');

        if (!tab) tab = 'Dashboard';

        this.setState({ DHCId }, () => this.getDHCDetails());

        this.onSelectTab(null, tab);
    }

    getDHCDetails = () => {
        var { DHCId } = this.state;

        this.props.GetDHCDetails({ DHCId }).then(({ DHCDetails }) => {
            this.setState({ DHCDetails });
        });
    }

    onSelectTab = (event, SelectedTab) => {
        this.setState({ SelectedTab });

        // Update the URL query parameter
        const params = new URLSearchParams(window.location.search);
        params.set('tab', SelectedTab);
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    }

    renderContent = () => {
        var { DHCDetails, DHCId, SelectedTab } = this.state;

        if (!Object.keys(DHCDetails).length) return null;

        if (SelectedTab === 'Dashboard') return <Dashboard DHCId={DHCId} />
        else if (SelectedTab === 'Budget') return <div>Budget</div>
        else if (SelectedTab === 'EndUsers') return <div>End Users</div>
        else if (SelectedTab === 'Products') return <div>Products</div>

        return null;
    }

    renderDHC = () => {
        var { DHCDetails } = this.state;
        var { DisplayName, UserPhoto } = DHCDetails;

        return (
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                <Avatar alt={DisplayName} sx={{ width: 100, height: 100 }} src={UserPhoto} />
                <Typography variant="h2">{DisplayName}</Typography>
            </Stack>
        );
    }

    renderToggleMenu = () => {
        return (
            <ToggleButtonGroup
                value={this.state.SelectedTab}
                exclusive
                onChange={this.onSelectTab}
                aria-label="text alignment"
                sx={{ display: "flex", justifyContent: "center" }}
            >
                {TAB_TYPES.map(({ id, IconName, TabLabel, Value }) => {
                    return (
                        <ToggleButton key={id} value={Value}>
                            <IconName />&nbsp;&nbsp;{TabLabel}
                        </ToggleButton>
                    );
                })}
            </ToggleButtonGroup>
        );
    }

    render() {
        return (
            <>
                {
                    this.props.TryingGetData &&
                    <Backdrop
                        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                        open={this.props.TryingGetData}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                }

                {this.renderDHC()}

                <Box sx={{ height: 40 }} />

                {this.renderToggleMenu()}

                <Box sx={{ height: 20 }} />
                
                {this.renderContent()}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        UserDetails: state.Auth.UserDetails,

        TryingGetData: state.Regular.TryingGetData,
        TryingGetDataError: state.Regular.TryingGetDataError
    }
}

export default connect(mapStateToProps, { GetDHCDetails })(DHCDetailWrapper);